import React from 'react';

export default function NotesField({ value, onChange, max }) {
    return (
        <div className="form-group" data-testid="demo-add-notes">
            <label htmlFor="demo-add-notes-field">
                {__('Notes')} <span className="demo-island-optional">{__('(optional)')}</span>
            </label>
            <textarea
                id="demo-add-notes-field"
                className="form-control"
                placeholder={__('Add any notes about this demo account...')}
                maxLength={max}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
            <small className="form-text text-muted text-right d-block">{`${value.length}/${max}`}</small>
        </div>
    );
}
